/**
 * @ngdoc controllers
 * @memberof mercury.modules.budget
 * @name BudgetWorksheetCtrl
 * @description Monthly budget worksheet to allow the editing of a days budget and compare them with sales
 */
angular.module('mercury.modules.budget.worksheet')
.controller('BudgetWorksheetCtrl', ["Budgets", "dialog", "$q", "reporttime", "ReportSales", "$scope", "$state", "$stateParams", "title", function(Budgets, dialog, $q, reporttime, ReportSales, $scope, $state, $stateParams, title) {
  title.set('Budget Worksheet');
  reporttime.setAllowedTypes(['month']);

  var startTime = moment(reporttime.start()).mStartOf('week').format();
  var endTime = moment(reporttime.end()).mStartOf('week').add(1, 'week').format();

  $scope.thisYear = moment(reporttime.start()).format('YYYY');
  $scope.lastYear = moment(reporttime.end()).subtract(1, 'day').subtract(1, 'year').format('YYYY');

  $scope.monthTotals = {
    salesCurrent: 0,
    salesPrevious: 0,
    taxCurrent: 0,
    taxPrevious: 0,
    budget: 0,
    budgetEx: 0
  };

  // subtract a year from the input date, then adjust to the nearest equivelent weekday
  // to match up the days to their same time last year, we need to adjust the date so it's the nearest same day
  // eg, Tuesday 6th October 2015 becomes Tuesday 7th October 2014 (since that's the nearest Tuesday to the 6th October 2014)
  var prevYearAdjusted = function(inputDate) {
    inputDate = moment(inputDate);
    var prevYearStart = moment(inputDate).subtract(1, 'year');
    var adjustment = inputDate.day() - prevYearStart.day();
    if (adjustment > 3) {
      adjustment = 7 - adjustment;
    } else if (adjustment < -3) {
      adjustment = adjustment + 7;
    }

    return prevYearStart.add(adjustment, 'days').format();
  };

  var updateTotals = function() {
    $scope.monthTotals.budget = 0;
    $scope.monthTotals.budgetEx = 0;

    angular.forEach($scope.weeks, function(week) {
      week.budget = 0;

      angular.forEach(week.days, function(day) {
        if (!day.budget.amount) {
          return;
        }

        week.budget += parseFloat(day.budget.amount);

        if (day.inMonth) {
          $scope.monthTotals.budget += parseFloat(day.budget.amount);
          $scope.monthTotals.budgetEx += parseFloat(day.budget.amount) / (1 + day.budget.salesTax);
        }
      });
    });
  };

  $scope.loading = $q.all({
    budgets: Budgets.getMonth(reporttime.time()),
    sales: ReportSales.getByDay(startTime, endTime),
    lastYearSales: ReportSales.getByDay(prevYearAdjusted(startTime), prevYearAdjusted(endTime))
  });

  $scope.loading.then(function(results) {
    var budgets = results.budgets;

    //map the budget into an hash
    var budgetsByStartTime = {};
    angular.forEach(budgets, function(budget) {
      budgetsByStartTime[moment(budget.date).mStartOf('day').format()] = budget;
    });

    // Map the current year sales into an object
    var currentSalesByDay = {};
    angular.forEach(results.sales, function(period) {
      currentSalesByDay[moment(period.startTime).format()] = {invoices: period.invoices, tax: period.invoicesTax};
    });

    // Map the previous year sales into an object
    var previousSalesByDay = {};
    angular.forEach(results.lastYearSales, function(period) {
      previousSalesByDay[moment(period.startTime).format()] = {invoices: period.invoices, tax: period.invoicesTax};
    });

    // initialize an array of week start dates for formatting purposes
    $scope.weeks = [];
    for (
      weekStartDate = moment(startTime);
      weekStartDate < moment(endTime);
      weekStartDate = weekStartDate.add(7, 'days')
    ) {
      var week = {
        days: [],
        salesCurrent: 0,
        salesPrevious: 0,
        budget: 0
      };

      for (i = 0; i < 7; i++) {
        var dayStart = moment(weekStartDate).add(i, 'days');

        var daysBudget;
        if (budgetsByStartTime[dayStart.format()]) {
          daysBudget = budgetsByStartTime[dayStart.format()];
        } else {
          daysBudget = {
            date: dayStart.clone().startOf('day').add(1, 'day').format(),
            amount: 0,
            salesTax: 1.15 // If you actually ever save this budget, this will be ignored and the server will use the company default tax preference
          };
        }

        var inMonth = moment(weekStartDate).add(i, 'days') >= moment(reporttime.start()) && moment(weekStartDate).add(i, 'days') < moment(reporttime.end());

        var daySalesCurrent = currentSalesByDay[dayStart.format()] ? currentSalesByDay[dayStart.format()].invoices : 0;
        var dayTaxCurrent = currentSalesByDay[dayStart.format()] ? currentSalesByDay[dayStart.format()].tax : 0;
        var daySalesPrevious = previousSalesByDay[prevYearAdjusted(dayStart.format())] ? previousSalesByDay[prevYearAdjusted(dayStart.format())].invoices : 0;
        var dayTaxPrevious = previousSalesByDay[prevYearAdjusted(dayStart.format())] ? previousSalesByDay[prevYearAdjusted(dayStart.format())].tax : 0;

        week.days.push({
          startTime: dayStart.format(),
          inMonth: inMonth,
          salesCurrent: daySalesCurrent,
          salesPrevious: daySalesPrevious,
          budget: daysBudget
        });

        if (inMonth) {
          $scope.monthTotals.salesCurrent += daySalesCurrent;
          $scope.monthTotals.taxCurrent += dayTaxCurrent;
          $scope.monthTotals.salesPrevious += daySalesPrevious;
          $scope.monthTotals.taxPrevious += dayTaxPrevious;
        }
      }

      $scope.weeks.push(week);
    }

    updateTotals();
  });

  $scope.updateBudget = function(day) {
    if ($scope.budgetForm['amount' + day.startTime].$invalid) {
      return;
    }

    day.saving = true;

    Budgets.update(day.budget)
    .then(function(result) {
      if (!day.budget.id) {
        day.budget.id = result.id;
        day.budget.salesTax = result.salesTax;
      }

      day.error = false;
      day.saved = true;
      day.saving = false;

      updateTotals();
    }, function() {
      day.error = true;
      day.saved = false;
      day.saving = false;
    });
  };
}]);
